// @flow
import type { IConstraintModel } from "../../types";

export type RegexObject = {
  messageKey: string,
  defaultMessage: string | null,
  regex: string | RegExp,
};

/**
 */
class RegexConstraint implements IConstraintModel {
  _regexConstraint: Object;

  /**
   */
  constructor(regexConstraint: RegexObject) {
    this._regexConstraint = regexConstraint;
  }

  /**
   */
  get id(): any {
    return this.regexConstraint.messageKey;
  }

  /**
   */
  get regexConstraint(): any {
    return this._regexConstraint;
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): any {
    return (
      this.regexConstraint.defaultMessage || this.regexConstraint.messageKey
    );
  }

  /**
   */
  get parameters(): { regex: any } {
    return {
      regex: this.regexConstraint.regex,
    };
  }

  /**
   */
  validate(value: string): boolean {
    if (this.regexConstraint.regex instanceof RegExp) {
      return this.regexConstraint.regex.test(value);
    }

    return new RegExp(this.regexConstraint.regex).test(value);
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default RegexConstraint;
